import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { getCheckerIcon } from "@/lib/checker-icons";

export default function CheckerCard({ checker }) {
  const Icon = getCheckerIcon(checker.icon);
  const accent = checker.category_color || "#002FA7";

  return (
    <Link
      to={`/checks/${checker.slug}`}
      className="group relative flex flex-col rounded-2xl border border-border bg-white p-6 hover:border-[#002FA7]/30 hover:shadow-[0_8px_30px_-12px_rgba(0,47,167,0.18)] hover:-translate-y-0.5 transition-all duration-200"
      data-testid={`checker-card-${checker.slug}`}
      style={{ "--accent": accent }}
    >
      <div className="flex items-start justify-between">
        <div className="relative h-12 w-12 rounded-xl flex items-center justify-center bg-slate-100 text-slate-700 group-hover:bg-[#002FA7]/8 group-hover:text-[#002FA7] transition-colors duration-200">
          <Icon className="h-5 w-5" strokeWidth={1.7} />
          {/* Subtiele category accent-toets — kleine gekleurde stip linksboven */}
          <span
            aria-hidden
            className="absolute -top-1 -left-1 h-2 w-2 rounded-full ring-2 ring-white"
            style={{ background: accent, opacity: 0.85 }}
          />
        </div>
        <span className="text-[10px] uppercase tracking-[0.14em] font-semibold px-2 py-1 rounded-full bg-slate-100 text-slate-500 inline-flex items-center gap-1.5">
          <span aria-hidden className="h-1.5 w-1.5 rounded-full" style={{ background: accent }} />
          {checker.category_label}
        </span>
      </div>

      <h3 className="font-editorial text-xl font-semibold text-ink mt-5" style={{ letterSpacing: "-0.015em" }}>
        {checker.display_name || checker.name}
      </h3>
      <p className="text-sm text-ink-soft mt-2 leading-relaxed line-clamp-2 font-modern">
        {checker.tagline}
      </p>

      <div className="mt-5 pt-4 border-t border-border flex items-center justify-between text-sm font-modern">
        <span className="font-semibold text-ink">€4,99</span>
        <span className="flex items-center gap-1 text-ink-soft group-hover:text-[#002FA7] transition-colors">
          Bekijk check <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
    </Link>
  );
}
